module.exports = __webpack_public_path__ + "img/dabiao_50W.851dd29b.png";